<template>
  <div>
    <GapTable></GapTable>
  </div>
</template>

<script>
import { GapTable } from "./components/index.js";
export default {
  components: {
    GapTable,
  },
};
</script>

<style lang="scss" scoped>
</style>